module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_purchases", [["div",{"class":"site-page favorites no-pb"},[["section",{"class":"purchases"}]]]]);
fox.registerTemplate("purchases_grid", [["div",{"class":"title-block"},[["div",{"class":"page-width z6"},[["div",{"class":"title editor-wrapper"},[["p",{},[["textNode",{"text":"My purchases"}]]]]]]]]],["section",{"class":"content-grid store-grid purchases-list"}],["div",{"class":"pager-wrapper"}]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader!./components/store/templates/purchasesGrid.tpl
// module id = 510
// module chunks = 4